@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';

.gift-banner {
  .paragraph();
  align-items: center;
  display: flex;
  gap: @space-8;
  color: var(--default--text-color--17);
}

.icon {
  color: var(--default--icon--fill-color--11);
  height: 14px;
  width: 14px;

  &.is-gift {
    color: var(--success--icon--fill-color--3);
  }
}
